import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  primary?: boolean;
  className?: string;
  onClick?: () => void;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  primary = false,
  className = '',
  onClick
}) => {
  return <motion.button className={`px-6 py-3 rounded-sm glass-button text-sm font-light tracking-wider ${primary ? 'border border-neon-blue/30 text-neon-blue' : 'border border-neon-blue/10 text-neon-blue/80'} ${className}`} onClick={onClick} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.2
  }} data-id="element-30">
      {children}
    </motion.button>;
};